import { NextOrderPayment } from "../../../model/orders/orders";

export const STORE_KEY = "bpnlId"

export enum AUTHORIZATION_STATUS{
    CARD_FAILURE = "card_failure",
    CARD_SUCESS = "card_success",
    DEBIT_SUCCESS = "success",
}

export enum PAYMENT_CHOICE{
    NEXT_INSTALLMENT,
    BALANCE
}

export interface PaymentInfo  {
    paymentChoice : PAYMENT_CHOICE | undefined;
    amount: number;
}